export default __webpack_public_path__ + "static/hnh-62ec904e34b083c8110030ec68fe63c0.png";